import axios from "axios";
import * as yup from "yup";
import { useFormik } from "formik";
import React, { useState } from "react";

import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  FormControl,
  DialogActions,
  DialogContent,
  FormHelperText,
} from "@material-ui/core";

import Loader from "../components/Loader";

export default function DeviceKFilterExceptionForm({
  initialData,
  deviceSerial,
  ruleId,
  existingIp,
  setMessage,
  setError,
  open,
  handleOpen,
  callback,
}) {
  const [loading, setLoading] = useState(false);
  const isEdit = Boolean(existingIp);

  const validateIPAddress = (address) => {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        address
      )
    ) {
      return true;
    }

    return false;
  };

  const validationSchema = yup.object({
    ip_address: yup
      .string("IP Address")
      .required("IP Address is required")
      .test("validate-ip", "Invalid IP address", validateIPAddress),
  });

  const addException = (requestData) => {
    if (!ruleId) {
      setError("KFilter rule ID is missing. Enable KFilter and refresh status.");
      formik.setSubmitting(false);
      return;
    }

    setLoading(true);

    axios
      .post(`/device/kfilter/exception/${deviceSerial}/${ruleId}`, requestData)
      .then(() => {
        setMessage("Added KFilter exception successfully.");
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Error adding exception");
      })
      .finally(() => {
        formik.setSubmitting(false);
        handleOpen(null);
        setLoading(false);
        callback && callback();
      });
  };

  const updateException = (currentIp, requestData) => {
    setLoading(true);

    axios
      .put(
        `/device/kfilter/exception/${deviceSerial}/${encodeURIComponent(
          currentIp
        )}`,
        requestData
      )
      .then(() => {
        setMessage("Updated KFilter exception successfully.");
      })
      .catch((error) => {
        setError(error?.response?.data?.detail || "Error updating exception");
      })
      .finally(() => {
        formik.setSubmitting(false);
        handleOpen(null);
        setLoading(false);
        callback && callback();
      });
  };

  const formik = useFormik({
    initialValues: initialData || { ip_address: "" },
    enableReinitialize: true,
    validationSchema: validationSchema,
    validateOnChange: true,
    onSubmit: (values) => {
      const requestData = { ip_address: values.ip_address };
      if (isEdit) {
        updateException(existingIp, requestData);
      } else {
        addException(requestData);
      }
    },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => handleOpen(null)}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">
          {isEdit ? "Update KFilter Exception" : "Add KFilter Exception"}
        </DialogTitle>
        <DialogContent>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12} sm={12}>
              <FormControl
                error={Boolean(formik.errors.ip_address)}
                sx={{ width: "100%" }}
              >
                <TextField
                  fullWidth
                  margin="dense"
                  id="ip_address"
                  label="IP Address"
                  onChange={formik.handleChange}
                  placeholder="IP Address"
                  value={formik.values.ip_address}
                />
                {Boolean(formik.errors.ip_address) && (
                  <FormHelperText id="ip_address-error-text">
                    {formik.errors.ip_address}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            disabled={loading || formik.isSubmitting || (!isEdit && !ruleId)}
            onClick={() => formik.submitForm()}
            variant="contained"
            color="primary"
          >
            {isEdit ? "Update Exception" : "Add Exception"}
          </Button>
          <Button onClick={() => handleOpen(null)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
